import { createFileRoute, notFound } from "@tanstack/react-router";
import ServicePage, { serviceSlugRedirects } from "@/pages/ServicePage";
import { legacyRedirect } from "@/lib/legacy-redirect";
import { isServiceSlug, serviceHead } from "@/lib/route-seo";
import NotFound from "@/pages/NotFound";

// Legacy slug redirects ported from src/App.tsx
const LEGACY_SLUGS: Record<string, string> = {
  "electrical-contracting": "/electrical-services/commercial-electrical-contractor",
  "service-repair": "/electrical-services/electrical-service-and-repair",
  "building-automation-systems": "/hvac-services/building-automation-systems",
  "switchgear-services": "/electrical-services/switchgear-installation",
  "emergency": "/electrical-services/emergency-electrical-service",
  "residential-electrical": "/electrical-services",
};

export const Route = createFileRoute("/electrical-services/$slug")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_SLUGS[params.slug];
    if (target) legacyRedirect(target);
    if (!isServiceSlug(params.slug) && !serviceSlugRedirects[params.slug]) throw notFound();
  },
  component: () => <ServicePage basePath="/electrical-services" baseLabel="Electrical Services" />,
  notFoundComponent: () => <NotFound hubPath="/electrical-services" hubLabel="Electrical Services" />,
  head: ({ params }) => serviceHead("/electrical-services", "Electrical Services", params.slug),
});
